module.exports = __webpack_public_path__ + "static/img/10.205c590.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/6/1/5/eng/10.png
// module id = MWoE
// module chunks = 0